import AddCreditCardForm from './AddCreditCardForm'
import { creditCardPendingSelector } from 'credit-cards/selectors'
import { addCreditCard, addGuestCreditCard } from 'credit-cards/actions'
import CircleLoader from 'shared/components/CircleLoader'
import ErrorMessage from 'shared/components/ErrorMessage'

const AddCreditCard = ({ addCreditCard, creditCardPending, successCallback, isGuestFlow, addGuestCreditCard }) => {
    const onTokenReceived = data => {
        if (isGuestFlow) {
            addGuestCreditCard(data, successCallback)
        } else {
            addCreditCard(data, successCallback)
        }
    }

    if (creditCardPending === true) {
        return <CircleLoader />
    }
    return (
        <>
            <AddCreditCardForm
                onTokenReceived={onTokenReceived}
                saveCardPending={creditCardPending}
                saveCardError={creditCardPending?.message}
            />
            {creditCardPending?.message && <ErrorMessage type="text" messages={[creditCardPending?.message]} />}
        </>
    )
}

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            creditCardPending: creditCardPendingSelector,
        }),
        { addCreditCard, addGuestCreditCard }
    )
)(AddCreditCard)
